/* eslint-disable react/prop-types */
/** @jsx createElement */
import Compressor from 'compressorjs';
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';
import TransferUploadButton from './TransferUploadButton';
import styles from './styles.less';

const MAX_FILES = 5;
const MAX_FILE_SIZE = 2 * 1024 * 1024;
const ALLOWED_TYPES = [
  /application\/*/,
  /image\/*/,
  /text\/*/,
  /video\/mp4/,
  /audio\/mpeg/,
];

const compress = async function (file) {
  if (!/image\/*/.test(file.type)) {
    return file;
  }

  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-new
    new Compressor(file, {
      quality: 0.8,
      mimeType: file.type,
      maxWidth: 2000,
      maxHeight: 1725,
      success: resolve,
      error: reject,
    });
  });
};

const handleFile = async function (file, onError) {
  if (!ALLOWED_TYPES.some((type) => type.test(file.type))) {
    onError('Oops, you can only upload images, videos and documents.');
    return undefined;
  }
  const blob = await compress(file);
  if (blob.size > MAX_FILE_SIZE) {
    onError('sizeExceeded');
    return undefined;
  }
  return blob;
};

const updateUploadButtonVisibility = (cmp, isOverflown) => {
  const uploadBtn = cmp.querySelector('.chat-transfer-upload-btn');
  if (!isOverflown) {
    if (uploadBtn?.style.display === 'none') {
      uploadBtn.style.display = '';
    }
  } else if (uploadBtn?.style.display !== 'none') {
    uploadBtn.style.display = 'none';
  }
};

const TransferUploadFile = function ({ translations, attachments }) {
  const removeFile = (cmp, files, fileId) => {
    files.removeChild(files.querySelector(`#${fileId}`));
    for (let i = attachments.length - 1; i >= 0; i -= 1) {
      if (attachments[i].id === fileId) {
        attachments.splice(i, 1);
      }
    }

    updateUploadButtonVisibility(cmp, attachments.length >= MAX_FILES);
  };

  const addFile = (cmp, files, file, blob) => {
    const fileId = `transferFile${Date.now()}`;
    attachments.push({
      id: fileId, blob, filename: file.name, mimetype: file.type,
    });

    updateUploadButtonVisibility(cmp, attachments.length >= MAX_FILES);

    files.appendChild(
      <div id={fileId} className={styles.chatTransferUploadItem}>
        <span title={file.name}>{file.name}</span>
        <button
          title={translations.removeFile}
          type="button"
          onClick={() => removeFile(cmp, files, fileId)}
        >X
        </button>
      </div>,
    );
  };

  const handleChange = (onError) => async ({ currentTarget } = {}) => {
    const cmp = currentTarget.closest('.uiComponent');
    const filesList = cmp.querySelector('.chat-transfer-upload-list');
    const attsLength = attachments.length;
    await Promise.all(Array.from(currentTarget.files)
      .map(async (file, i) => {
        if ((attsLength + i) >= MAX_FILES) return;

        const blob = await handleFile(file, onError);
        if (!blob) return;

        addFile(cmp, filesList, file, blob);
      }));
    // eslint-disable-next-line no-param-reassign
    currentTarget.value = '';
  };

  const onError = (err) => {
    const msg = err === 'sizeExceeded' ? translations.uploadFileMaxSize : err;
    const errorWrapper = document.querySelector('.chat-transfer-upload-error');
    if (errorWrapper) {
      errorWrapper.textContent = msg;
      setTimeout(() => { errorWrapper.textContent = ''; }, 5000);
    }
  };

  return (
    <div className={`uiComponent embeddedServiceSidebarFormField ${styles.chatTransferUploadCmp}`}>
      <div className="uiInput uiInputText uiInputDefaultError uiInput--default uiInput--input">
        <TransferUploadButton
          onChange={handleChange(onError)}
          label={translations.uploadFile}
          className="chat-transfer-upload-btn"
        />
        <div className="form-element__help chat-transfer-upload-error" />
        <div className={`chat-transfer-upload-list ${styles.chatTransferUploadList}`} />
      </div>
    </div>
  );
};

export default TransferUploadFile;
